import React, { useContext, useMemo } from 'react';

import ProjectContext from '../../contexts/project-context';

interface CompanyLogoProps {
  className?: string;
}

const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = '/images/logos/default.png';
};

export const CompanyLogo: React.VFC<CompanyLogoProps> = ({ className }) => {
  const projectContext = useContext(ProjectContext);

  const imgSrc = useMemo(() => {
    const companyKey = projectContext?.project?.projectKey
      ?.split('-')[0]
      ?.toLowerCase();

    if (companyKey == null || projectContext?.isLoading) {
      return null;
    }

    return `/images/logos/${companyKey}.png`;
  }, [projectContext?.isLoading, projectContext?.project?.projectKey]);

  if (imgSrc == null) {
    return null;
  }

  return (
    <img className={className} src={imgSrc} alt='Logo' onError={handleError} />
  );
};
